export const AUTH_BASE_URL = process.env.REACT_APP_API_AUTH_BASE_URL;
export const REST_BASE_URL = process.env.REACT_APP_REST_API;
